export default __webpack_public_path__ + "static/illustration-crosslisting-9473d3561bb7bec643477d415885e4f2.png";